/**
 * Banner text (GDD §6.2, §7.3; judgment call 30): each §7.3 banner shows its headline, with the rest of its text
 * beneath, e.g. "LEVEL 3" over "ENEMY JETS INBOUND · BRIDGE GUNS ONLINE". Built once per banner shown.
 */
import { config } from '../core/config.ts';
import type { Banner } from '../rules/announcer.ts';

export interface BannerText {
  head: string;
  sub: string;
}

/** Headline and sub-line for a banner (GAME OVER's scores are added by the HUD). */
export function bannerText(b: Banner, out: BannerText = { head: '', sub: '' }): BannerText {
  const t = config.text;
  switch (b.key) {
    case 'level':
      out.head = `${t.levelPrefix} ${b.level}`;
      out.sub = t.levelBanners[b.level - 1] ?? t.levelBannerAfter;
      break;
    case 'bridge': {
      // "BRIDGE DESTROYED +500": the points go beneath.
      const i = t.bridgeDestroyed.lastIndexOf(' +');
      out.head = i > 0 ? t.bridgeDestroyed.slice(0, i) : t.bridgeDestroyed;
      out.sub = i > 0 ? t.bridgeDestroyed.slice(i + 1) : '';
      break;
    }
    case 'extraJet':
      out.head = t.extraJet;
      out.sub = '';
      break;
    case 'jetLost':
      out.head = t.jetLostPrefix;
      out.sub = b.cause ? t.jetLost[b.cause] : '';
      break;
    case 'gameOver':
      out.head = t.gameOver;
      out.sub = '';
      break;
  }
  return out;
}

/** The banner's full §7.3 text on one line, e.g. "JET LOST · OUT OF FUEL" (tests, screen readers). */
export function bannerLine(b: Banner): string {
  const { head, sub } = bannerText(b);
  if (!sub) return head;
  return b.key === 'bridge' ? `${head} ${sub}` : `${head} · ${sub}`;
}
